import React, { useState, useEffect, useMemo } from 'react';
import Select from "react-select";
import { useTranslation } from "react-i18next";
import axios from 'axios';

function CompCrmDistrictDropdown({ onChange, selectedOption, cascadeOption, isDisabled }) {
    const { t } = useTranslation();
    const [componentId] = useState('districtList');

    const [selectedItem, setSelectedItem] = useState({});
    const [optionsListData, setOptionsListData] = useState([]);

    React.useMemo(() => {
        let list = [];
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            if (cascadeOption !== '-1') {
                axios.get(ApiGateway + '/crm/general/city/' + cascadeOption + "/district/search-and-list")
                    .then(response => {
                        if (response.data?.isSucceed === true) {
                            list.push({ label: t('select.default.option.choose'), value: '-1' });
                            response.data?.payload?.forEach((item) => {
                                list.push({ label: item.name, value: item.id });
                            });
                        }
                        setOptionsListData(list);
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        }
    }, [t, cascadeOption]);

    useEffect(() => {
        let selected = {};
        optionsListData?.forEach((item) => {
            if (selectedOption !== null && item.value === selectedOption) {
                selected = { label: item.label, value: item.value };
            }
        });
        setSelectedItem(selected);
    }, [t, cascadeOption, selectedOption, optionsListData]);

    const handleChangeSelect = (e) => {
        setSelectedItem({ label: e?.label, value: e?.value });
        onChange(e.value);
    };

    return (
        <React.Fragment>
            <div>
                {(optionsListData !== null && selectedItem !== null) ? (
                    <Select aria-label=".form-select-sm" classNamePrefix="select2-selection form-select" id={componentId}
                        noOptionsMessage={() => t('select.default.option.no-options')} isDisabled={isDisabled === true ? "disabled" : ""} isOptionDisabled={(option) => option.isdisabled}
                        options={optionsListData} onChange={handleChangeSelect} value={selectedItem} selected={selectedItem?.value} />
                ) : (
                    <p>Yükleniyor...</p>
                )}
            </div>
        </React.Fragment>
    );
}
export default CompCrmDistrictDropdown;